import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { DeleteIconButton } from '../../../../components/common/button/CustomIconButton';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import { convToTime } from '../../../../utils/helpers';
import { TimePicker } from '@mui/x-date-pickers';

interface IProps {
  moduleData: any;
  isView: boolean;
  handelDeleteRows: any;
}
const TBody = ({ moduleData, isView, handelDeleteRows }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tbody>
      {moduleData.histories &&
        moduleData.histories.map((spec: any, index: number) => (
          <tr>
            <td style={{ minWidth: '150px', width: '150px' }}>
              {isView ? (
                formatDate(spec.date)
              ) : (
                <DatePickerMui
                  value={moment(spec.date)}
                  onChange={(date) => {
                    spec.date = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </td>
            <td>
              <TableInput
                isView={isView}
                name="type_of_breakdown"
                type="text"
                value={spec.type_of_breakdown}
                onChange={(e) => {
                  spec.type_of_breakdown = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td style={{ minWidth: '150px', width: '150px' }}>
              {isView ? (
                convToTime(spec?.break_down_reporting_time)
              ) : (
                <TimePicker
                  value={moment(spec?.break_down_reporting_time || '')}
                  onChange={(date) => {
                    spec.break_down_reporting_time = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </td>
            <td>
              <TableInput
                isView={isView}
                name="root_cause"
                type="text"
                value={spec.root_cause}
                onChange={(e) => {
                  spec.root_cause = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td>
              <TableInput
                isView={isView}
                name="action_taken"
                type="text"
                value={spec.action_taken}
                onChange={(e) => {
                  spec.action_taken = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td>
              <TableInput
                isView={isView}
                name="sign"
                type="text"
                value={spec.sign}
                onChange={(e) => {
                  spec.sign = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td colSpan={isView ? 2 : 1}>
              <TableInput
                isView={isView}
                name="remarks"
                type="text"
                value={spec.remarks}
                onChange={(e) => {
                  spec.remarks = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            {!isView && (
              <td style={{ minWidth: '100px', textAlign: 'center' }}>
                <DeleteIconButton
                  tooltipTitle={'delete'}
                  onClick={() => handelDeleteRows(index)}
                />
              </td>
            )}
          </tr>
        ))}
    </tbody>
  );
};

export default TBody;
